import {
  Box,
  ContentBlock,
  Dropdown,
  Hidden,
  Inline,
  Text,
} from 'braid-design-system';
import type { FormEvent } from 'react';
import { useNavigate } from 'react-router';

import { links } from 'src/links';
import type { RouteProps } from 'src/types';
import { useQuery } from 'src/utils/hooks/useQuery';

import { Link } from '../Link/Link';

import * as styles from './Nav.css';

const navLinks: RouteProps[] = [
  links.CONNECT_WITH_SEEK,
  links.CONNECTED_PARTERS,
  links.LINK_YOUR_SOFTWARE,
];

interface NavProps {
  activeTab?: string;
}

// Styling mimics https://github.com/SEEK-Jobs/wpt-cms-unification/blob/b8f2b87275cb378112aa6639cdac5025df6bccfb/libs/components/src/modules/SectionMenu/SectionMenu.tsx#L23
// so that switching between partner hub pages looks OK
export const Nav = ({ activeTab }: NavProps) => {
  const navigate = useNavigate();
  const version = useQuery().get('v');

  const mobileChange = (e: FormEvent<HTMLSelectElement>) => {
    const path = (e.target as HTMLSelectElement).value;
    // TODO track this link
    navigate({
      pathname: path,
      ...(version ? { search: `?v=${version}` } : {}),
    });
  };

  return (
    <Box component="nav" background="neutralSoft">
      <Hidden below="tablet">
        <ContentBlock width="large">
          <Box display="flex" alignItems="center">
            {navLinks.map((item) => {
              const isActive = `/${activeTab}` === item.path;

              return (
                <Link href={item.path} tracking={item.tracking} key={item.path}>
                  <Box
                    paddingX="small"
                    paddingY="medium"
                    className={styles.tab[`${isActive}`]}
                  >
                    <Text
                      tone={isActive ? 'link' : 'neutral'}
                      size="small"
                      weight={isActive ? 'strong' : 'regular'}
                    >
                      {item.name}
                    </Text>
                  </Box>
                </Link>
              );
            })}
          </Box>
        </ContentBlock>
      </Hidden>

      <Hidden above="mobile">
        <Box paddingY="small" width="full">
          <Inline space="none" align="center">
            <Dropdown
              aria-label="Navigation"
              id="sub-nav"
              onChange={mobileChange}
              value={`/${activeTab}`}
            >
              {navLinks.map((link, i) => (
                <option key={i} value={link.path}>
                  {link.name}
                </option>
              ))}
            </Dropdown>
          </Inline>
        </Box>
      </Hidden>
    </Box>
  );
};
